(function () {
  'use strict';

  var colors = ['#ff3d12', '#ffb020', '#ffe66d', '#2fbf71', '#2f80ed', '#b85cff', '#ff6b9d'];
  var celebratedCards = new WeakSet();

  function celebrate(card) {
    if (!card || celebratedCards.has(card)) return;
    celebratedCards.add(card);
    card.classList.add('bm-celebrating');

    var layer = document.createElement('div');
    layer.className = 'bm-coupon-celebration';
    layer.setAttribute('aria-hidden', 'true');

    for (var index = 0; index < 56; index += 1) {
      var piece = document.createElement('span');
      if (index % 6 === 0) piece.className = 'bm-celebration-streamer';
      piece.style.setProperty('--x', ((index * 37) % 101) + '%');
      piece.style.setProperty('--delay', ((index % 9) * 0.045) + 's');
      piece.style.setProperty('--duration', (1.65 + (index % 7) * 0.11) + 's');
      piece.style.setProperty('--rotate', ((index * 53) % 360) + 'deg');
      piece.style.setProperty('--drift', (((index % 5) - 2) * 24) + 'px');
      piece.style.setProperty('--color', colors[index % colors.length]);
      layer.appendChild(piece);
    }

    card.appendChild(layer);
    window.setTimeout(function () {
      layer.remove();
      card.classList.remove('bm-celebrating');
    }, 2900);
  }

  function scan() {
    document.querySelectorAll('.cart-coupon-card').forEach(function (card) {
      if (card.classList.contains('is-applied')) {
        celebrate(card);
      }
    });
  }

  var observer = new MutationObserver(scan);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }
})();